import { gql } from '@apollo/client';

const query = gql`
  mutation DeleteReview($id: String!) {
    deleteReview(id: $id) {
      success
    }
  }
`;

module.exports = query;
